// https://momentjs.com/docs
import moment from 'moment';
import { i18n } from '@src/i18n-setup';

/**
 * Given an ISO string or JS Date object, returns the corresponding string.
 *
 * @param {Object} raw - The raw date string (eg: '2018-12-01')
 * @return {Date} The result string Eg. '1 Dec 2018'
 */
export default function getDateString(date = new Date()) {
  moment.locale(i18n.locale);

  return moment(date).format('D MMM YYYY');
}
